"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findTitle = findTitle;
var _public = require("@/api/public/public");
// let v = window.location.hostname;
// let path = v.indexOf(".");
// let provId = v.substring(0, path);
// if (provId == '') {
//   // provId='sichuan'
//   provId = 'qinghai'
// }
// if (provId == 'qinghai') {
//   provId = 'qinghai'
// }
function findTitle() {
  // return new Promise((resolve, reject) => {
  //   webConfig({
  //     param: 'beijing'
  //   })
  //     .then(res => {
  //       const { data } = res;
  //       sessionStorage.setItem(
  //         "book",
  //         JSON.stringify(data.expertAuthentication)
  //       );
  //       resolve(res.data.title);
  //     })
  //     .catch(err => {
  //       reject(err);
  //     });
  // });
}